import React, { Component } from 'react';


class ShowIff extends Component {
	render() {
		if (this.props.iff)
			return <div className={"ShowIff " + (this.props.className || "")}>{this.props.children}</div>;
		return <div className={"ShowIff empty " + (this.props.className || "")}></div>;
	}
}

export default ShowIff;
